import {
    api_companies_get,
    api_user_patch,
    api_user_sessions_del,
    api_user_sessions_list,
    Province,
    UserSession,
} from 'abi'
import {
    addAlert,
    HoverInp,
    LoadingDots,
    LoadingElem,
    PassCheck,
    setPopup,
} from 'components'
import {
    CalendarIcon,
    CloseIcon,
    CorpsIcon,
    DeleteIcon,
    DevicesIcon,
    IpIcon,
    LogoutIcon,
    MapIcon,
    PassIcon,
    RoleIcon,
    ShieldCheckIcon,
    UserIcon,
    WarningIcon,
} from 'icons'
import {
    Component,
    createEffect,
    createMemo,
    createSignal,
    For,
    on,
    onCleanup,
    onMount,
    Show,
} from 'solid-js'
import { createStore, produce } from 'solid-js/store'
import { logoutUser, self, setSelf } from 'store/self'

import './style/profile.scss'

const Profile: Component = () => {
    return (
        <div class='profile-section section'>
            <div class='profile-wrapper'>
                <ProfileField />
                <CorpField />
                <PassField />
                <MySessions />
            </div>
        </div>
    )
}
export const PROVINCE_FA: Record<Province, string> = {
    none: 'بدون استان',
    all: 'همه استان‌ها',
    tehran: 'تهران',
    alborz: 'البرز',
    ardabil: 'اردبیل',
    bushehr: 'بوشهر',
    chaharmahal_bakhtiari: 'چهارمحال و بختیاری',
    fars: 'فارس',
    gilan: 'گیلان',
    golestan: 'گلستان',
    hamadan: 'همدان',
    hormozgan: 'هرمزگان',
    ilam: 'ایلام',
    isfahan: 'اصفهان',
    kerman: 'کرمان',
    kermanshah: 'کرمانشاه',
    khuzestan: 'خوزستان',
    kohgiluyeh_and_boyer_ahmad: 'کهگیلویه و بویراحمد',
    kurdistan: 'کردستان',
    lorestan: 'لرستان',
    markazi: 'استان مرکزی',
    mazandaran: 'مازندران',
    qazvin: 'قزوین',
    qom: 'قم',
    north_khorasan: 'خراسان شمالی',
    razavi_khorasan: 'خراسان رضوی',
    south_khorasan: 'خراسان جنوبی',
    semnan: 'سمنان',
    sistan_baluchestan: 'سیستان و بلوچستان',
    east_azerbaijan: 'آذربایجان شرقی',
    west_azerbaijan: 'آذربایجان غربی',
    yazd: 'یزد',
    zanjan: 'زنجان',
}

const ProfileField: Component = () => {
    type STATE = {
        name: string
        username: string
        created: number
        province: Province
        error: string
    }
    const [state, setState] = createStore<STATE>({
        name: self.user?.name || '',
        username: self.user?.username || '',
        created: self.user?.created_at || 0,
        error: '',
        province: 'none',
    })

    createEffect(() => {
        setState({
            name: self.user?.name || '',
            username: self.user?.username || '',
            created: self.user?.created_at || 0,
            province: self.user?.province || 'none',
        })
    })

    const changed = createMemo(() => ({
        name: state.name != self.user!.name,
        username: state.username != self.user!.username,
    }))

    const isDisable = createMemo(() => ({
        name: state.name.length == 0,
        username: state.username.length == 0,
    }))

    const save = async () => {
        if (isDisable().name)
            return setState('error', 'اسم نمیتواند خالی باشد!')
        if (isDisable().username)
            return setState('error', 'نام کاربری نمیتواند خالی باشد!')

        setSelf({ loading: true })

        let res = await api_user_patch(
            {
                old_password: null,
                password: null,
                username: state.username,
                name: state.name,
            },
            {
                show_alert: true,
            }
        )

        setSelf({ loading: false })

        if (!res.ok()) return

        let { name, username } = res.body

        setSelf('user', {
            name,
            username,
        })
        addAlert({
            type: 'success',
            timeout: 3,
            subject: 'موفق!',
            content: 'اطلاعات با موفقیت ثبت شد!',
        })
    }

    return (
        <fieldset class='field-cmp profile-field'>
            <legend class='leg title_hero'>
                <UserIcon />
                اطلاعات کاربری
            </legend>

            <div class='wrapper'>
                <HoverInp
                    class={
                        changed().name
                            ? isDisable().name
                                ? 'red'
                                : 'green'
                            : ''
                    }
                    Icon={<UserIcon />}
                    inpType='text'
                    value={state.name}
                    holder={'نام'}
                    onInp={e => setState({ name: e, error: '' })}
                    acitve={state.name.length !== 0}
                    name='hamrahName'
                    showReset={!!changed().name && !!self.user!.name}
                    onReset={() => setState({ name: self.user?.name || '' })}
                    onEnter={() => {
                        if (!changed().name) return

                        save()
                    }}
                />
                <HoverInp
                    class={
                        changed().username
                            ? isDisable().username
                                ? 'red'
                                : 'green'
                            : ''
                    }
                    Icon={<UserIcon />}
                    inpType='text'
                    value={state.username}
                    holder={'نام کاربری'}
                    onInp={e => setState({ username: e, error: '' })}
                    acitve={state.username.length !== 0}
                    name='hamrahUsername'
                    showReset={changed().username}
                    onReset={() =>
                        setState({ username: self.user?.username || '' })
                    }
                    onEnter={() => {
                        if (!changed().username) return

                        save()
                    }}
                />
                <HoverInp
                    Icon={<CalendarIcon />}
                    inpType='text'
                    value={new Date(state.created * 1e3).toLocaleDateString(
                        'fa-IR'
                    )}
                    holder={'تاریخ عضویت'}
                    disable
                    onInp={() => {}}
                    acitve={true}
                    name=''
                />
                <HoverInp
                    Icon={<MapIcon />}
                    inpType='text'
                    value={PROVINCE_FA[state.province]}
                    holder={'استان کاربر'}
                    disable
                    onInp={() => {}}
                    acitve={true}
                    name=''
                />
            </div>

            <div
                class='error-wrapper title_small'
                classList={{ show: !!state.error }}
            >
                <WarningIcon />
                {state.error}
            </div>

            <div class='cta-wrapper'>
                <button
                    class='cta title_smaller'
                    disabled={!changed().name && !changed().username}
                    onclick={save}
                >
                    تایید
                </button>
            </div>
        </fieldset>
    )
}
const CorpField: Component = () => {
    const [state, setState] = createStore({
        role: '',
        corp: '',

        loading: true,
    })

    createEffect(
        on(
            () => self.user,
            async u => {
                if (!u?.staff_at)
                    return setState({
                        loading: false,
                        role: 'بدون نقش!',
                        corp: 'بدون شرکت!',
                    })

                setState('loading', true)

                let res = await api_companies_get({ cid: u.staff_at })
                setState('loading', false)

                if (!res.ok()) return

                setState({
                    role: u.staff_role == 'agent' ? 'نماینده' : 'مدیرعامل',
                    corp: res.body.name,
                })
            }
        )
    )

    const Loader: Component = () => {
        return (
            <div
                class='loader title_hero'
                classList={{ active: state.loading }}
            >
                <LoadingDots />

                <p>درحال گرفتن اطلاعات از سرور</p>
            </div>
        )
    }

    return (
        <fieldset class='field-cmp profile-field'>
            <legend class='leg title_hero'>
                <CorpsIcon />
                اطلاعات شرکت
            </legend>
            <div class='wrapper'>
                <Loader />

                <HoverInp
                    Icon={<UserIcon />}
                    inpType='text'
                    value={state.corp}
                    holder={'شرکت عضویت'}
                    onInp={e => setState({ corp: e })}
                    acitve={state.corp.length !== 0}
                    name='hamrahUsernam'
                    disable
                />
                <HoverInp
                    Icon={<RoleIcon />}
                    inpType='text'
                    value={state.role}
                    holder={'نقش'}
                    onInp={e => setState({ role: e })}
                    acitve={state.role.length !== 0}
                    name='hamrahRole'
                    disable
                />
            </div>
        </fieldset>
    )
}
const PassField: Component = () => {
    const [state, setState] = createStore({
        oldP: '',
        newP: '',
        newP2: '',

        loading: false,
        disable: true,
    })

    const show = createMemo(() => state.newP.length !== 0)

    const save = async () => {
        if (state.disable) {
            return addAlert({
                type: 'error',
                content: 'لطفا تمام نیاز های رمز را کامل کنید.',
                timeout: 3,
                subject: 'خطا!',
            })
        }

        if (state.newP !== state.newP2) {
            return addAlert({
                type: 'error',
                content: 'رمز های عبور جدید مطابقت ندارند!',
                timeout: 3,
                subject: 'خطا!',
            })
        }
        if (!state.oldP) {
            return addAlert({
                type: 'error',
                content: 'رمز عبور حاضر خود را وارد  کنید!',
                timeout: 3,
                subject: 'خطا!',
            })
        }

        setState({ loading: true })

        let res = await api_user_patch(
            {
                name: self!.user?.name || '',
                username: self.user?.username || '',
                old_password: state.oldP,
                password: state.newP,
            },
            { show_alert: true }
        )
        setState({ loading: false })

        if (!res.ok()) return

        addAlert({
            type: 'success',
            subject: 'موفق!',
            timeout: 3,
            content: 'رمز عبور شما با موفقیت تغییر یافت.',
        })
        setState({
            newP: '',
            newP2: '',
            oldP: '',
        })
    }

    return (
        <fieldset class='field-cmp pass-field'>
            <div
                class='loader title_hero'
                classList={{ active: state.loading }}
            >
                <LoadingDots />
                درحال ارتباط با سرور
            </div>
            <legend class='leg title_hero'>
                <PassIcon />
                تغییر رمز
            </legend>
            <div class='diags'></div>
            <div class='wrapper'>
                <HoverInp
                    Icon={<PassIcon />}
                    inpType='password'
                    value={state.oldP}
                    holder={'رمز عبور حاضر'}
                    onInp={e => setState({ oldP: e })}
                    acitve={state.oldP.length !== 0}
                    name='hamrahUsernam'
                />

                <div class='row'>
                    <HoverInp
                        Icon={<ShieldCheckIcon />}
                        inpType='password'
                        value={state.newP}
                        holder={'رمز عبور جدید'}
                        onInp={e => setState({ newP: e })}
                        acitve={state.newP.length !== 0}
                        name=''
                    />
                    <HoverInp
                        Icon={<ShieldCheckIcon />}
                        inpType='password'
                        value={state.newP2}
                        holder={'تکرار رمز'}
                        onInp={e => setState({ newP2: e })}
                        acitve={state.newP2.length !== 0}
                        name=''
                    />
                </div>
            </div>

            <PassCheck
                maxLength={12}
                pass={state.newP}
                show={show()}
                onPassed={s => setState({ disable: !s })}
            />

            <div class='cta-wrapper'>
                <button
                    class='cta title_smaller'
                    disabled={state.disable}
                    onclick={save}
                >
                    تایید
                </button>
            </div>
        </fieldset>
    )
}
const MySessions: Component = () => {
    type st = {
        loading: boolean
        sessions: UserSession[]
        error: boolean
    }
    const [state, setState] = createStore<st>({
        loading: true,
        sessions: [],
        error: false,
    })

    onMount(async () => {
        setState({ loading: true })

        let res = await api_user_sessions_list()
        setState({ loading: false })

        if (!res.ok()) return setState({ error: true })

        setState({ sessions: res.body })
    })

    onCleanup(() => {
        setState({
            loading: true,
            sessions: [],
            error: false,
        })
    })

    const LoadingSessions: Component = () => {
        return (
            <div class='loading title'>
                <div class='icon'>
                    <LoadingDots />
                </div>
                <p>درحال گرفتن اطلاعات از سرور</p>
            </div>
        )
    }

    const Error: Component = () => {
        return (
            <div class='error title'>
                <div class='icon'>
                    <CloseIcon />
                </div>
                <p>خطا در گرفتن اطلاعات از سرور</p>
                <span class='title_smaller'>
                    لطفا بعد از مدتی، دوباره تلاش کنید
                </span>
            </div>
        )
    }

    const Session: Component<UserSession> = P => {
        const [loading, setLoading] = createSignal(false)

        const deleteDevice = async () => {
            setLoading(true)

            if (isSelf()) return logoutUser()

            let res = await api_user_sessions_del(
                { sid: P.id },
                { show_alert: true }
            )

            if (!res.ok()) return

            addAlert({
                type: 'success',
                timeout: 3,
                subject: 'موفق!',
                content: 'دستگاه با موفقیت حذف شد.',
            })

            setState(
                produce(s => {
                    let id = s.sessions.findIndex(a => a.id == P.id)

                    if (id == -1) return

                    s.sessions.splice(id, 1)
                })
            )
        }

        const isSelf = createMemo(() => {
            let userId = self.user?.id || -1

            return userId == P.id
        })

        return (
            <Show
                when={!loading()}
                fallback={<LoadingElem class='loading-session' />}
            >
                <div class='session-card'>
                    <div class='icon-wrapper'>
                        <div class='icon' classList={{ active: isSelf() }}>
                            <DevicesIcon />
                        </div>
                    </div>

                    <div class='card'>
                        <div class='head '>
                            <span class='title_hero'>دستگاه شماره {P.id}</span>
                            <Show when={isSelf()}>
                                <span class='self title_smaller'>
                                    (دستگاه شما)
                                </span>
                            </Show>
                        </div>

                        <div class='info'>
                            <div class='row'>
                                <div class='holder title_smaller'>
                                    <CalendarIcon />
                                    تاریخ ورود
                                </div>
                                <div class='data title_small'>
                                    {new Date(
                                        P.timestamp * 1e3
                                    ).toLocaleDateString('fa-IR')}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='holder title_smaller'>
                                    <IpIcon />
                                    آیپی دستگاه
                                </div>
                                <div class='data title_small'>{P.ip}</div>
                            </div>
                        </div>

                        <button
                            class='cta title_smaller'
                            onclick={() => {
                                setPopup({
                                    show: true,
                                    Icon: DeleteIcon,
                                    title: 'مطمعن هستید؟',
                                    type: 'error',
                                    timer: 2,
                                    content:
                                        'بعد از حذف دستگاه، باید مجددن با دستگاه ورود کنید!',
                                    onSubmit() {
                                        deleteDevice()
                                    },
                                })
                            }}
                        >
                            <Show
                                when={!isSelf()}
                                fallback={
                                    <>
                                        <LogoutIcon />
                                        خروج از حساب
                                    </>
                                }
                            >
                                <DeleteIcon />
                                حذف دستگاه
                            </Show>
                        </button>
                    </div>
                </div>
            </Show>
        )
    }

    return (
        <fieldset class='field-cmp sessions-field'>
            <legend class='leg title_hero'>
                <DevicesIcon />
                دستگاه های من
            </legend>

            <Show when={!state.loading} fallback={<LoadingSessions />}>
                <Show when={!state.error} fallback={<Error />}>
                    <div class='sessions-wrapper'>
                        <For each={state.sessions}>
                            {s => <Session {...s} />}
                        </For>
                    </div>
                </Show>
            </Show>
        </fieldset>
    )
}

export default Profile
